// extracted by mini-css-extract-plugin
module.exports = {"milestone-flag-logo":"Fb9tO5y","milestoneFlagLogo":"Fb9tO5y","milestone-payment-title":"fb4ox4w","milestonePaymentTitle":"fb4ox4w"};